// @flow
import * as React from 'react';

import useLatest from './useLatest';

const useTimeout = (callback: () => void, delay: number | null) => {
    const callbackRef = useLatest(callback);

    React.useEffect(() => {
        const tick = () => {
            callbackRef.current();
        };
        if (delay !== null) {
            const id = setTimeout(tick, delay);
            return () => clearTimeout(id);
        }
    }, [delay, callbackRef]);
};

export default useTimeout;
